var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"filter-title"},[_vm._v("Challenge")]),_vm._v(" "),_vm._l((_vm.$store.state.event.data.challenges),function(challenge){return _c('router-link',{key:challenge.nom,staticClass:"button_course",class:{
      isCurrent: _vm.$store.state.event.selection.challenge === challenge.nom,
    },attrs:{"type":"button","size":"sm","target":"_self","to":{
        name: 'Challenge',
        query: { id: _vm.$store.state.event.id, c: challenge.nom },
      },"refresh":""}},[_vm._v(_vm._s(challenge.nom))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9348f78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/Epreuve/SelectionChallenge.vue
// module id = null
// module chunks = 